import { localizeUrl } from "./languageRouting";

export const modifyUrlWithLanguage = (url, language) =>
  localizeUrl(url, language);
